import { text as getTextColor, N30, N800, R400, Y400 } from '@atlaskit/theme/colors';
import { borderRadius as getBorderRadius, gridSize as getGridSize } from '@atlaskit/theme/constants';
export var width = {
  values: ['small', 'medium', 'large', 'x-large'],
  widths: {
    small: 400,
    medium: 600,
    large: 800,
    'x-large': 968
  },
  defaultValue: 'medium'
};
export var gutter = 60;
var gridSize = getGridSize();
export var borderRadius = getBorderRadius();
export var verticalOffset = gridSize * 2;
export var padding = gridSize * 3;
export var footerItemGap = gridSize;
export var titleIconMargin = gridSize;
export var keylineHeight = 2;
export var keylineColor = N30;
export var textColor = getTextColor();
export var focusOutlineColor = N800;
export var iconColor = {
  danger: R400,
  warning: Y400
};